export default __webpack_public_path__ + "static/media/nosotros.e87b4a87.webp";